<!--suppress ALL -->
<template>
  <div>
    <modals-container name="modal1" />
    <v-dialog/>
    <!--资源管理左侧菜单-->
    <div id="zy_menu_left" class="col_2_1 w180 zy_menu_left" style="height:100%; overflow:hidden;">
      <span><a @click="editClassification('f', null, '', '0', '0')"  class="add2"></a></span>
      <dl class="main_menu" v-for="item in RCTree" :key="item.id">
            <span>
              <dt class="total-scope">
                <a href="javascript:;" @click="searchByClassification(item.id)" class="total-scope-name" :title="item.name">{{item.name}}</a>
                <a href="javascript:void(0);" @click="editClassification('s', null, '', item.id, '0')" class="addSub" title="添加子类"></a>
                <i class="edit"  @click="editClassification('f', item.name, item.id, item.parentId, item.parent_ids)"></i>
                <a href="javascript:;" @click="delRC(item.id)"><i class="del main_menu_del"></i></a><i class="up_icon icon_c"></i>
              </dt>
              <!--此处字数请程序控制不超过7个汉字-->
              <ul class="ul1 total-scope-tan subUL">
                <dd v-for="n in item.nodes" :key="n.id">
                  <a href="javascript:;" @click="searchByClassification(n.id)" class="subTitle">{{n.name}}</a> <i class="edit" @click="editClassification('s', n.name, n.id, n.parentId, n.parent_ids)"></i>
                  <a href="javascript:;" @click="delRC(n.id)"><i class="del delSub"></i></a>
                </dd>
                <P>
                </P>
              </ul>
            </span>
      </dl>
      <dl class="all-tags" @click="searchByClassification()">全部</dl>
    </div>
    <!--/资源管理左侧菜单-->
    <!--资源管理右侧列表-->
    <div class="col_2_2 w797 zy_right">
      <div class="zy_right_title">标签管理</div>
      <div class="gj_top_class">
        <input name="" type="button" class="btn_s_gj" @click="searchByFilter()" /><input name="title" type="text" class="put_gj" placeholder="请输入标签名称" v-model="filter.content" @keyup.13="searchByFilter()"/>
        <a class="btn btn_add" @click="editResource('')">新增标签</a>
        <a @click="delUsers(selected)" style="background: #ff3633;">批量删除</a>
      </div>
      <div class="gj__list" style="min-height:670px;">
        <el-table v-if="tableData.data && tableData.data.length > 0"
                  :data="tableData.data" stripe border @selection-change="updateSelected"
                  style="width: 100%">
          <el-table-column
            type="selection"
            width="55">
          </el-table-column>
          <el-table-column
            prop="content" label="标签名称">
          </el-table-column>
          <el-table-column
            prop="cnt" label="热度" sortable>
          </el-table-column>
          <el-table-column prop="tag" label="用途分类" :filters="[{ text: '人员', value: '01' }, { text: '部门', value: '02' }]"
                           :filter-method="filterTag" filter-placement="bottom-end">
            <template slot-scope="scope">
              <span v-if="scope.row.type == '01'">人员</span>
              <span v-if="scope.row.type == '02'">部门</span>
            </template>
          </el-table-column>
          <el-table-column label="操作" width="80">
            <template slot-scope="scope">
              <a title="编辑" class="el-icon-edit" @click="editResource(scope.row.id)" style="cursor: pointer;"></a>
              <a title="删除" class="el-icon-delete" @click="del(scope.row)" style="cursor: pointer;"></a>
              <a title="批量打标签" class="el-icon-my-tag" @click="showRange(scope.row)" style="cursor: pointer;"></a>
            </template>
          </el-table-column>
        </el-table>
        <h5 class="none_ts" v-if="tableData.data.length == '0'">
          <img src="@/assets/images/none_data.jpg" alt="">
        </h5>
      </div>
      <div class="zy_list_bottom">
        <dl>
          <dt>共{{resourceCnt}}个标签</dt>
          <dd v-if="resourceCnt > 0">
            <paginate :click-handler="clickCallback" :page-count = pages
                      :container-class=$global.paginationOptions.container_class :page-class=$global.paginationOptions.page_class :page-link-class=$global.paginationOptions.page_link_class
                      :prev-class=$global.paginationOptions.prev_class :prev-link-class=$global.paginationOptions.prev_link_class
                      :next-class=$global.paginationOptions.next_class :next-link-class=$global.paginationOptions.next_link_class
                      :first-last-button=$global.paginationOptions.first_last_button
                      :active-class=$global.paginationOptions.active_class
                      :disabled-class=$global.paginationOptions.disabled_class
                      :first-button-text=$global.paginationOptions.first_button_text
                      :last-button-text=$global.paginationOptions.last_button_text
                      :prev-text=$global.paginationOptions.prev_text
                      :next-text=$global.paginationOptions.next_text>
            </paginate>
          </dd>
        </dl>
      </div>
    </div>
    <!--/资源管理右侧列表-->

    <!--添加大类弹出-->
    <div class="tan add_b_menu" style="display:none;">
      <div class="add_con">
        <dl>
          <dt><input name="" type="text"  v-model="name_f" placeholder="请输入大类名称"/></dt>
          <!--<dt style="height:35px;"><input name="" type="text"  v-model="name_f_sort" placeholder="请输入排序"/></dt>-->
          <dd><input name="" type="button" value="取消" @click="$utils.fadeOut('.add_b_menu')" />　　<input type="button" value="确定" class="red_color" @click="submitClassification(name_f, name_f_sort)" /></dd>
        </dl>
      </div>
    </div>
    <!--/添加大类弹出-->
    <!--添加子类弹出-->
    <div class="tan add_s_menu" style="display:none;">
      <div class="add_con">
        <dl>
          <dt><input name="" type="text"  v-model="name_s" placeholder="请输入子类名称"/></dt>
          <!--<dt><input name="" type="text"  v-model="name_s_sort" placeholder="请输入排序"/></dt>-->
          <dd><input name="" type="button" value="取消" @click="$utils.fadeOut('.add_s_menu')" />　　<input type="button" value="确定" class="red_color" @click="submitClassification(name_s, name_s_sort)" /></dd>
        </dl>
      </div>
    </div>
    <!--/添加子类弹出-->
  </div>
</template>
<script>
  import api from '@/api/index'
  import config from '@/config/index'
  import BylTable from '@/components/common/table/index.vue'
  import Dropdown from '@/store/modules/dropdowns'
  import {init} from '@/assets/js/public'
  import Paginate from 'vuejs-paginate'
  import router from '@/router'
  import utils from '@/utils'
  import Bus from '@/utils/bus'
  import { mapState, mapActions } from 'vuex'
  import ModalBox from '@/components/common/modal/index.vue'
  import rangeManip from '@/components/byl/rangeManip/index.vue'
  export default {
    components: { Paginate, BylTable },
    data () {
      return {
        Dropdown: Dropdown,
        filter: {
          pageNo: 1,
          pageSize: 15,
          content: "",
          classificationId: ""
        },
        selected: [],
        tableData: {
          columns: [
            {
              field: 'content',
              title: '标签名称',
              colWidth: 220
            },
            {
              field: 'classificationName',
              title: '标签分类',
              colWidth: 220
            },
            {
              field: 'type',
              title: '用途分类',
              colWidth: 80
            }
          ],
          actions: ['edit', 'del'],
          data: []
        },
        RCTree: [],
        allCheck: '',
        pages: 0,
        resourceCnt: 0,

        name_f: '',
        name_s: '',
        name_f_sort: '0',
        name_s_sort: '0',

        classification: {},
        resourceInfo: {},
        putOnOffArr: [],
        prefix: this.$route.meta.prefix || ''
      }
    },
    created () {
      this.getResourceClassification()
      this.getResources(this.filter)
    },
    mounted () {
      this.$nextTick(() => {
        init()
      })
      Bus.$on('initData_/org/resourceList', (data) => { // 点击菜单“资源管理”重置数据
        this.filter =  {
          pageNo: 1,
          pageSize: 15,
          type: "",
          state: ""
        }
        this.getResources(this.filter)
      })
    },
    computed: {
    },
    methods: {
      confirmBox (o) {
        var that = this
        this.$modal.show('dialog', {
          title: o.title,
          text: o.text,
          buttons: [
            {
              title: '确认',
              default: true,
              handler: utils.debounce(() => {
                if (o.yes && o.yes instanceof Function) {
                  o.yes()
                  that.$modal.hide('dialog') // !!!必须清掉模态框，否则在别的页面按enter键会触发方法的
                }
              }, 1000)
            },
            {
              title: '取消'
            }
          ]
        })
      },
      filterTag (value, row) {
        return row.type === value;
      },
      del (item) {
        if (item) {
          var that = this
          this.confirmBox({
            title: '删除',
            text: '删除标签后，当前与组织架构中的人员、部门建立的标签关系也将一并删除，确认删除吗？',
            yes: function () {
              api.post(config.tagApiPath, '/tagInfo/delete', {ids: item.id}, function (r) { // 正常
                that.$toasted.show('删除成功')
                that.$modal.hide('dialog')
                that.searchByFilter()
              })
            }
          })
        }
      },
      delUsers (items) {
        if (items.length > 0) {
          var that = this
          this.confirmBox({
            title: '删除',
            text: '确认删除吗?',
            yes: function () {
              var ids = utils.arr2str(utils.grabVal(items, 'id'))
              api.post(config.tagApiPath, '/tagInfo/delete', {ids: ids}, function (r) { // 正常
                that.$toasted.show('删除成功')
                that.$modal.hide('dialog')
                that.searchByFilter()
              })
            }
          })
        } else {
          this.$toasted.show('没有删除项')
        }
      },
      updateSelected (val) {
        this.selected = val
      },
      clickCallback (pageNum) {
        this.filter.pageNo = pageNum
        this.getResources(this.filter)
      },
      // 编辑大分类
      editClassification (type, name, id, parentId, parentIds) {
        if (type == 'f' && name == null) {
          this.$utils.fadeIn('.add_b_menu')
          this.name_f = ''
          // this.name_f_sort = ''
        } else if (type == 's' && name == null) {
          this.$utils.fadeIn('.add_s_menu')
          this.name_s = ''
          parentIds = parentIds + ','+parentId
          // this.name_s_sort = ''
        } else if (type == 'f' && name != null) {
          this.$utils.fadeIn('.add_b_menu')
          this.name_f = name
          // this.name_f_sort = sort
        } else if (type == 's' && name != null) {
          this.$utils.fadeIn('.add_s_menu')
          this.name_s = name
          // this.name_s_sort = sort
        }
        this.classification = {
          id: id,
          name: name,
          parentId: parentId,
          parent_ids: parentIds
          // sort: sort
        }
      },
      submitClassification (name, sort) {
        if (name && name != '') {
          this.classification.name = name
          this.classification.sort = sort
          this.$api.post(this.$global.tagApiPath, '/tagClassification/edit', this.classification, r => {
            this.$utils.fadeOut('.add_b_menu')
            this.$utils.fadeOut('.add_s_menu')
            this.classification = {}
            this.getResourceClassification()
          })
        }
      },
      searchByClassification (id) {
        this.filter = {
          pageNo: 1,
          pageSize: 15,
          classificationId: id,
          type: "",
          content: ""
        }
        this.getResources(this.filter)
      },
      searchByFilter () {
        this.filter.pageNo = 1
        this.getResources(this.filter)
      },
      getResources (filter) {
        this.$api.post(this.$global.tagApiPath, '/tagInfo/findList', filter, r => {
          if (r.data) {
            this.resourceCnt = r.cntData
            this.pages = Math.ceil(r.cntData / this.filter.pageSize)
            this.tableData.data = r.data
          } else {
            this.tableData.data = []
            this.pages = 0
            this.resourceCnt = 0
          }
        })
      },
      editResource (id) {
        if (id == '') {
          id = 'create'
        }
        this.$router.push({path: this.prefix + '/org/tag/'+ id})
      },
      delRC (id) {
        this.$api.getRestful(this.$global.tagApiPath, '/tagClassification/delete', {id: id}, r => {
          this.getResourceClassification()
        })
      },
      getResourceClassification () {
        this.$api.get(this.$global.tagApiPath, '/tagClassification/findList', {}, r => {
          let tree = r
          this.RCTree = tree.data
        })
      },
      putOnOff (type, id, e) {
        e.stopPropagation();
        this.putOnOffArr = []
        var action
        if (type == 'on') {
          action = '5'
          this.$utils.fadeIn('.open_btn')
        } else if (type == 'off') {
          action = '4'
          this.$utils.fadeIn('.stop_btn')
        }
        this.putOnOffArr.push(id)
      },
      submitPutOnOff (action, idArr) {
        var idStr = ''
        for (var i = 0; i<idArr.length; i++) {
          if (i < idArr.length -1) {
            idStr += idArr[i] + ','
          } else if (i == idArr.length -1) {
            idStr += idArr[i]
          }
        }
        this.$api.get(this.$global.resourceApiPath, '/resource/action/batch', {action: action, ids: idStr}, r => {
          if (action == '4') {
            this.$utils.fadeOut('.stop_btn')
          } else if (action == '5') {
            this.$utils.fadeOut('.open_btn')
          }
          this.getResources(this.filter)
        })
      },
      viewResource (id, type, e) {
        e.stopPropagation();
        this.$api.get(this.$global.resourceApiPath, '/resource/view/' + id, {}, r => {
          this.resourceInfo = r.data
          if (type=='2') {
            this.$refs.videoPlayer.player.src(this.resourceInfo.filePathMp4)
            this.$utils.fadeIn('.resourcePreview')
          } else {
            window.open(this.resourceInfo.filePathMp4, '_black')
          }
        })
      },

      closeViewModal () {
        this.$utils.fadeOut('.resourcePreview')
        this.$refs.videoPlayer.player.pause()
      },
      showRange (item) {
        var that = this
        if (item.type == '01') { // 取人员
          this.getTagPeople(item).then((r) => {
            var result = []
            if (r && r.length > 0) {
              r.forEach((o) => {
                o.uitype = '02'
              })
              result = r
            }  else {
              result = []
            }
            this.setRangeBox(result, item)
          })
        } else if (item.type == '02') { // 取部门
          this.getTagDepts(item).then((r) => {
            var result = []
            if (r && r.length > 0) {
              r.forEach((o) => {
                o.uitype = '01'
              })
              result = r
            } else {
              result = []
            }
            this.setRangeBox(result, item)
          })
        }
      },
      setRangeBox (r, item) {
        var that = this
        this.$modal.show(ModalBox, {
          opts: {
            title: '批量打标签',
            styles: {
              width: '960',
              height: String(0.8242 * window.screen.availHeight)
            },
            currentComponent: {
              name: 'range',
              template: rangeManip,
              outputsKey: 'outputs', // 该组件对外输出数据时，定义的key值
              tabs: ['org'],
              hidePeople: (item.type == '01') ? false : true,
              treeViewOptions: {
                multiselect: (item.type == '01') ? false : true
              },
              inputs: r // 向组件内传入的数据, 一般用于初始化
            },
            yes (val) { // 点击确认后要做的事情
              if (val && val.length > 0) {
                var itemArr = []
                var params = {}
                if (item.type == '01') { // 人员
                  itemArr = val.filter((o) => {
                    return o.uitype == '02'
                  })
                } else if (item.type == '02') { // 部门
                  itemArr = val.filter((o) => {
                    return o.uitype == '01'
                  })
                }
                params.teamTagList = [{
                  tagId: item.id,
                  itemId: utils.arr2str(utils.grabVal(itemArr, 'id')),
                  type: item.type
                }]
                that.bondTagItems(params).then((r) => {
                  that.$toasted.show('批量打标签成功')
                })
              }
            },
            closed () { // 这里要判断, 只有新增状态下需要清空
              //
            }
          }
        })
      },
      getTagPeople (item) {
        var that = this
        return new Promise(function (resolve, reject) {
          that.$api.post(that.$global.bylApiPath, '/msg/tagSearchByMember', {tagId: item.id}, r => {
            resolve(r.data)
          })
        })
      },
      getTagDepts (item) {
        var that = this
        return new Promise(function (resolve, reject) {
          that.$api.post(that.$global.bylApiPath, '/msg/tagSearchByDep', {tagId: item.id}, r => {
            resolve(r.data)
          })
        })
      },
      bondTagItems (p) {
        var that = this
        return new Promise(function (resolve, reject) {
          that.$api.post(that.$global.tagApiPath, '/teamTag/batchEdit', p, r => {
            resolve(r.data)
          })
        })
      }
    }
  }
</script>
<style lang="scss" scoped>
  .all-tags {
    height: 36px;
    width: 170px;
    margin-top: 0px;
    position: relative;
    border-bottom: 1px solid #f0f0f0;
    font-size: 12px;
    padding-left: 10px;
    line-height: 36px;
    cursor: pointer;
  }
</style>



// WEBPACK FOOTER //
// src/page/byl/org/tag/list.vue